import React from "react";
// import {  } from 'material-ui'

const StudyGroupTitle = ({ title }) => (
  <h5 className="studygroup_title">{title}</h5>
);

export default StudyGroupTitle;



// WEBPACK FOOTER //
// ./src/components/Admin/StudyGroups/StudyGroupTitle.jsx